export function isAbortError(err) {
  if (!err) return false;
  if (err.name === 'AbortError') return true;
  const msg = typeof err === 'string' ? err : (err.message || String(err));
  return /signal is aborted/i.test(msg)
    || /aborted a request/i.test(msg)
    || /\bAbortError\b/i.test(msg);
}

export function safeAbort(controller, reason = 'cancelled') {
  if (!controller) return;
  try {
    if (!controller.signal?.aborted) controller.abort(reason);
  } catch {
    // ignore — abort during unmount must never surface
  }
}

/** Browser extensions (e.g. injectScriptAdjust.js) — not app code. */
export function isBenignExternalScript(filename, stack = '') {
  const src = `${filename || ''}\n${stack || ''}`;
  return /injectScriptAdjust/i.test(src)
    || /chrome-extension:\/\//i.test(src)
    || /moz-extension:\/\//i.test(src)
    || /safari-extension:\/\//i.test(src);
}

function shouldSuppressError(err, stack = '') {
  return isAbortError(err) || isBenignExternalScript('', stack);
}

export function installBenignErrorFilters() {
  if (typeof window === 'undefined' || window.__shippingBenignErrorFilters) return;
  window.__shippingBenignErrorFilters = true;

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const stack = reason?.stack || '';
    if (shouldSuppressError(reason, stack)) {
      event.preventDefault();
      event.stopImmediatePropagation?.();
    }
  }, true);

  window.addEventListener('error', (event) => {
    if (shouldSuppressError(event.error, event.error?.stack)) {
      event.preventDefault();
      event.stopImmediatePropagation?.();
    }
  }, true);

  const hook = window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__;
  if (hook && typeof hook.onUnhandledError === 'function' && !hook.__shippingAbortPatched) {
    const orig = hook.onUnhandledError;
    hook.onUnhandledError = (error) => {
      if (shouldSuppressError(error, error?.stack)) return;
      orig(error);
    };
    hook.__shippingAbortPatched = true;
  }
}